import React from "react";
import PropTypes from "prop-types";

export const GreenButton = ({ label, isActive, onClick }) => (
  <button
    className={`flex-1 p-1 rounded-lg font-bold cursor-pointer text-center transition-all duration-300 
      ${isActive ? "bg-green-600 text-white hover:bg-green-700" : "bg-green-50 text-green-600 hover:bg-green-100 border border-green-600"}`}
    onClick={onClick}
  >
    {label}
  </button>
);

export const BlueButton = ({ label, isActive, onClick }) => (
  <button
    className={`flex-1 p-1 rounded-lg font-bold cursor-pointer text-center transition-all duration-300 
      ${isActive ? "bg-blue-900 text-white hover:bg-blue-950" : "bg-blue-50 text-blue-900 hover:bg-blue-100 border border-blue-900"}`}
    onClick={onClick}
  >
    {label}
  </button>
);

export const RedButton = ({ label, isActive, onClick }) => (
  <button
    className={`flex-1 p-1 rounded-lg font-bold cursor-pointer text-center transition-all duration-300 
      ${isActive ? "bg-red-600 text-white hover:bg-red-700" : "bg-red-50 text-red-600 hover:bg-red-100 border border-red-600"}`}
    onClick={onClick}
  >
    {label}
  </button>
);

export const GrayButton = ({ label, onClick }) => (
  <button
    className="p-1 rounded-lg text-gray-600 bg-gray-100 hover:bg-gray-200 cursor-pointer text-center transition-all duration-300 border border-gray-300"
    onClick={onClick}
  >
    {label}
  </button>
);

GreenButton.propTypes = BlueButton.propTypes = RedButton.propTypes = {
  label: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

GrayButton.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
